<section>
	<div class="spinner-custom"></div>
	<span class="spinner-text"
		>Un momento, por favor.<br />
		Estamos cargando la información que solicitaste.</span
	>
</section>
